<template>
  <div>
    <bubble style="width: 100%; position: relative;">
      <!-- <i
        v-show="refData && isCurrentUser"
        class="ivu-icon ivu-icon-android-settings edit-btn"
        @click="onClick">
      </i> -->
      <span v-show="isCurrentUser" class="edit-btn" @click="$refs['ellipsis'].setEllipsis()">
        <Icon :type="isCollapsed ? 'arrow-up-b':'arrow-down-b'"></Icon>
      </span>
      <div>
        <ellipsis
          ref="ellipsis"
          @expanded="onExpand"
          @collapsed="onCollapse"
          v-if="refData"
          :byWord="true"
          :is-current-user="isCurrentUser"
          :content="refData" />
        <div v-else >
          <p style="color: #BDBDBD" @click="onClick">
            Write something about yourself.
          </p>
        </div>
      </div>
    </bubble>
     <Modal
      v-model="modal"
      :loading="loading"
      draggable
      scrollable
      ok-text="Save"
      :transfer="true"
      :closable="false"
      :mask-closable="false"
      @on-ok="saving"
      title="About Me">
       <Input
        v-model="inputData"
        type="textarea"
        :rows="4"
        placeholder="Write something about yourself."/>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'ViewPublicProfileAboutMe',
  data() {
    return {
      modal: false,
      inputData: null,
      loading: true,
      isCollapsed: false
    }
  },
  computed: {
    refData() {
      if (this.isCurrentUser)
        return this.$store.state.user.info.about_me
      return this.$store.state.publicProfile.info.data.about_me
    },
    isCurrentUser: {
      get() {
        return this.$store.state.user.info.id == this.$store.state.publicProfile.info.data.id;
      }
    },
  },

  methods: {
    onExpand() {
      this.isCollapsed = true
    },
    onCollapse() {
      this.isCollapsed = false
    },
    onClick() {
      this.modal = this.loading = true
      this.inputData = this.refData
      console.log(this.inputData)
    },
    saving() {
       this.$store.dispatch("user/updateUserInfo", {id: this.$store.state.user.info.id ,data: {
         about_me: this.inputData
       }}).then(() => {
         console.log('test');
         this.modal = this.loading = false
       })
    }
  }
}
</script>

<style scoped>
 .edit-btn {
   position: absolute;
   top: 10px;
   right: 10px;
   z-index: 1;
 }
</style>
